import * as React from 'react';

function ReceptionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.101646 12.3065C-0.0249539 12.5116 -0.033921 12.7724 0.0782644 12.9864C0.19045 13.2005 0.405882 13.3336 0.639998 13.3336L6.27164 13.3336C6.27175 13.3336 6.27186 13.3336 6.27198 13.3336H7.03997H15.4879C15.6752 13.3336 15.8476 13.2254 15.9373 13.0515C16.0271 12.8776 16.0199 12.6657 15.9186 12.4991L11.3106 4.91574C11.2164 4.76071 11.0542 4.66699 10.88 4.66699C10.7057 4.66699 10.5435 4.76071 10.4493 4.91574L9.20294 6.96683L6.93833 2.97315C6.82057 2.78234 6.61774 2.66699 6.39997 2.66699C6.18221 2.66699 5.97938 2.78234 5.86162 2.97315L0.101646 12.3065ZM8.50763 8.11109L6.39997 4.56649L1.81226 12.0003H6.14436L8.50763 8.11109ZM10.88 6.66698L14.0799 12.0003H7.67997L10.88 6.66698Z"
        fill="#CFD4DA"
      />
    </svg>
  );
}

const MemoReceptionIcon = React.memo(ReceptionIcon);
export default MemoReceptionIcon;
